export const userConsts = {

    CHANGE_USER_PERSONAL_DATA: "CHANGE_USER_PERSONAL_DATA",
    CHANGE_AVATAR: "CHANGE_AVATAR",
    CHANGE_STATUS: "CHANGE_STATUS",
    CHANGE_PHONE: "CHANGE_PHONE",
    CHANGE_LOGIN: "CHANGE_LOGIN",
    CHANGE_NICKNAME: "CHANGE_NICKNAME",
    CHANGE_EMAILSUB: "CHANGE_EMAILSUB",
    UPDATE_USER_DATA: "UPDATE_USER_DATA",
    CHANGE_STATUS_NOTIFY: "CHANGE_STATUS_NOTIFY",
    LEAVE_TEAM: "LEAVE_TEAM",
    ADD_TEAM: "ADD_TEAM",
    DELETE_ACCOUNT: "DELETE_ACCOUNT",

    LOADING_STATUS: {
        LOADED: "USER_LOADED",
        NOT_LOADED: "USER_NOT_LOADED",
        LOADING: "USER_LOADING",
        REGISTERED: "REGISTERED",
    },

    STATUS: {
      VERIFIED: "verified",
      IDENTIFIED: "identified",
    },

    TYPE_AWARDS: {
        GOLD: "GOLD",
        SLIVER: "SLIVER",
        BRONZE: "BRONZE",
    },

    RANKS: {
        YULING: "Юнлинг",
        PADAWAN: "Падаван",
        KNIGHT: "Рыцарь",
        MASTER: "Магистр",
        GRAND_MASTER: "Великий магистр",
    },

    OTHER_DICT_KEYWORD: 'Другое',
    CODE_SKILLS_NONE: 'Не владею'
};

export const typeNotification = {
    INVITATION: "inv",
    NEWS: "news",
    MERGE_INVITE: "cominv",
};




// WEBPACK FOOTER //
// src/constants/users.jsx